import { useQuery } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { makeRequest } from "../../../utils/axios.js"; 

export const useProfileStats = () => {
    const location = useLocation();
    const userId = parseInt(location.pathname.split("/")[2]);

    const { isLoading: isFollowersLoading, data: followersData } = useQuery({
        queryKey: ["followers", userId],
        queryFn: () => makeRequest.get(`/relationships?followedUserId=${userId}`).then((res) => res.data),
    });

    const { isLoading: isFollowingLoading, data: followingData } = useQuery({
        queryKey: ["following", userId],
        queryFn: () => makeRequest.get(`/relationships/following?followerUserId=${userId}`).then((res) => res.data),
    });

    const { isLoading: isFriendsLoading, data: friendsData } = useQuery({
        queryKey: ["friends", userId],
        queryFn: () => makeRequest.get(`/friendships/friends?userId=${userId}`).then((res) => res.data),
    });

    return {
        followersCount: followersData?.length || 0,
        isFollowersLoading,
        followingCount: followingData?.length || 0,
        isFollowingLoading,
        friendsData,
        isFriendsLoading,
    };
};